const BASE_URL = '/lishui-gov'

import request from '@/common/api/request'

// 是否在申领时间内
export const getEntWhiteSettingByType = (params) => request(BASE_URL + '/govEntWhite/getEntWhiteSettingByType', { params })
// 提交申领
export const insertOrUpdate = (data) => request.post(BASE_URL + '/govEntWhite/insertOrUpdate', data)
// 申领详情
export const entWhiteDetail = (params) => request(BASE_URL + '/govEntWhite/govWhiteDetail', { params })
// 申领记录
export const listRecords = (params) => request(BASE_URL + '/govEntWhite/listRecords', { params })
// 企业类型
export const getEntType = (params) => request(BASE_URL + '/govEntWhite/getEntType', { params })
// 文件上传
export const uploadFileByContentType = process.env.VUE_APP_BASE_API + BASE_URL + '/api/file/uploadFileByContentType'

// 企业申请白名单状态
export const  entWhiteCouponStatus =  (params) => request(BASE_URL + '/govEntWhite/govEntWhiteCouponStatus', { params })
